import(/* webpackMode: "eager" */ "/builds/cef-cloud/common-components/city-chat/client/src/app/page.tsx");
